import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const CustomerStatistic = ApplicationRecord.extend({
  attrs: {
    shipped_one_feeds_two_meals_count: attr(),
    customer_id: attr(),
  },
  static: {
    endpoint: '/customer_statistics',
    jsonapiType: 'deliveries-customer_statistics',
  },
});

export default CustomerStatistic;
